import { HTMLAttributes } from 'react';
import { Clear } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import clsx from 'clsx';

type DialogHeaderProps = HTMLAttributes<HTMLDivElement> & {
  hideClose?: boolean;
  hideBottomLine?: boolean;
  close?: () => void;
  title?: string;
};

const DialogHeader = (props: DialogHeaderProps) => {
  const { className, children, hideClose, close, hideBottomLine, title } =
    props;

  /**
   * methods
   */
  const closeAction = () => {
    close?.();
  };

  return (
    <Box
      className={clsx(
        'flex h-[70px] flex-row items-center space-x-2 pl-5 pr-2',
        { 'border-b border-neutral-300': !hideBottomLine },
        className
      )}
    >
      <Box className="w-0 flex-1">
        {title ? (
          <Typography variant="h6" className="font-bold text-black">
            {title}
          </Typography>
        ) : (
          children
        )}
      </Box>
      {!hideClose && (
        <Box>
          <IconButton onClick={closeAction}>
            <Clear className="h-8 w-8" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default DialogHeader;
